<script lang="tsx" setup>
defineProps<{
  href: string
  text: string
}>()
</script>

<template>
  <a class="link" :href="href" target="_blank" v-html="text" />
</template>
